import {type VariantProps, tv} from 'tailwind-variants'
import {type ExtractStrict} from 'type-zoo'
import {HgAspectRatio} from '~/design-system/hg/components'

export type HgHeroSplitImageLongProps = {
  size: ExtractStrict<VariantProps<typeof splitImageVariants>['size'], 'long'>
  assetOneOneRatio: React.ReactNode
  assetFourFiveRatio: React.ReactNode
}

export type HgHeroSplitImageShortProps = {
  size: ExtractStrict<VariantProps<typeof splitImageVariants>['size'], 'short'>
  assetOneOneRatio: React.ReactNode
}

export type HgHeroSplitImageSizeProps =
  | HgHeroSplitImageLongProps
  | HgHeroSplitImageShortProps

export type HgHeroSplitImageProps = {
  type: 'splitImage'
  logoAsset: React.ReactNode
} & VariantProps<typeof splitImageVariants> &
  HgHeroSplitImageSizeProps

const splitImageVariants = tv({
  slots: {
    assetFourFive:
      'col-span-full lg:col-span-8 lg:col-start-9 xl:col-span-6 xl:col-start-9',
    assetOneOne: 'col-span-full',
  },
  variants: {
    size: {
      long: {
        assetFourFive: 'sm:block md:hidden lg:block',
        assetOneOne: 'hidden md:block lg:hidden',
      },
      short: {
        assetOneOne: 'lg:col-span-8 lg:col-start-9 xl:col-span-6 xl:col-start-9',
      },
    },
  },
})

export default function HgHeroSplitImageVariant(props: HgHeroSplitImageProps) {
  const {assetFourFive, assetOneOne} = splitImageVariants({size: props.size})
  return (
    <>
      {props.size === 'long' && (
        <HgAspectRatio
          aspectRatio="4:5"
          topSpacing="s9"
          classNames={{
            wrapper: assetFourFive(),
            assetWrapper: 'object-position-top h-full',
          }}
        >
          {props.assetFourFiveRatio}
        </HgAspectRatio>
      )}
      <HgAspectRatio
        aspectRatio="1:1"
        topSpacing="s9"
        classNames={{
          wrapper: assetOneOne(),
        }}
      >
        {props.assetOneOneRatio}
      </HgAspectRatio>
    </>
  )
}
